import React from 'react'
import type { FieldSurface } from './fieldSurfaces/types'

const FieldSurfaceContext = React.createContext<FieldSurface>('form')

export function FieldSurfaceProvider({
  surface,
  children,
}: {
  surface: FieldSurface
  children: React.ReactNode
}) {
  return <FieldSurfaceContext.Provider value={surface}>{children}</FieldSurfaceContext.Provider>
}

export function useFieldSurface(): FieldSurface {
  return React.useContext(FieldSurfaceContext)
}

/** Surface hiệu lực: prop ưu tiên, không có thì lấy từ provider. */
export function resolveFieldSurface(surfaceProp: FieldSurface | undefined): FieldSurface {
  const fromContext = React.useContext(FieldSurfaceContext)
  return surfaceProp ?? fromContext
}
